import { Grid } from "@mui/material";
import {
  FormikDialog,
  FormikTextField,
  updateCacheAfterAdd
} from "@placehires/react-component-library";
import React from "react";
import { useCreateIndustryMutation } from "../../generated/graphqlHooks";
import { ErrorCode, IndustriesDocument } from "../../generated/graphqlTypes";

type CreateIndustryProps = {
  open: boolean;
  handleClose: () => void;
};

const CreateIndustryModal: React.FC<CreateIndustryProps> = ({ open, handleClose }) => {
  const [createIndustry] = useCreateIndustryMutation();

  return (
    <FormikDialog
      open={open}
      onClose={handleClose}
      title="Create new Industry"
      formikConfig={{
        initialValues: {
          name: ""
        },
        onSaveSubmit: async (values) => {
          await createIndustry({
            variables: values,
            update: (cache, mutationResult) => {
              updateCacheAfterAdd(cache, IndustriesDocument, mutationResult.data?.createIndustry);
            }
          });
        },
        errorsToFieldName: {
          [ErrorCode.CONFLICT]: {
            fieldName: "name",
            customErrorMessage: "Industry with this name already exists!"
          }
        }
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormikTextField required name="name" autoFocus fullWidth />
        </Grid>
      </Grid>
    </FormikDialog>
  );
};

export default CreateIndustryModal;
